module.exports = __webpack_public_path__ + "img/23-min.0959ec58.jpg";